module.exports = __webpack_public_path__ + "static/media/boothMobile.18d4f7b9.jpg";